<template>
  <app-view-template-secondary class="app-view-default-template-compliance" title="Data security<br>and compliance" :brands="brands">
    <div>
      <app-content-title label="Data security and compliance"></app-content-title>
    </div>

    <section>
      <article>
        <p>
          Data security and compliance with all regulations has never been more important or challenging.
          Countries are introducing new or updated data protection and compliance regulations continuously.
          Loyal Solutions is born as a digital native and with security and compliance as a part of our DNA.
          In any loyalty program, a range of rules and regulations apply, at Loyal Solutions we will guide you and
          ensure your program is deployed in each country according to applicable regulations.<br><br>

          In partnership with our client’s security teams we work continuously to assess and improve data security.
          Our approach is diversified and adapted to client requirements including but not limited to:
        </p>
      </article>

      <article>
        <h4>Single tenant solution – security by design</h4>

        <p>
          All our solutions utilize our market leading platform, LoyalTfacts&reg;, and each is deployed as a 100% 
          independent (single tenant) deployment that does not share any components with any other client solution. 
          It is truly a private cloud SaaS platform.
        </p>
      </article>

      <article>
        <h4>PCI DSS Level 1 certified</h4>

        <p>
          PCI DSS is the payment card industry’s global security regulations and one of the most demanding and comprehensive standards. 
          Loyal Solutions is PCI DSS Level 1 certified. This is an all-encompassing continuous process, checking all systems, procedures,
          and protocols. Our independent assessor is: Nixu Cybersecurity
        </p>
      </article>

      <article>
        <h4>PCI DSS Level 1 certified hosting</h4>

        <p>
          Loyal Solutions only uses state-of-the-art data centers that are PCI DSS Level 1 certified. 
          Our standard is Google Cloud Platform, but we can also if client or regulatory needs requires, 
          deploy at AWS or other PCI DSS compliant centers.
        </p>
      </article>

      <article>
        <h4>ISO27001, 27017, 027018 Certified ISMS</h4>
        <p>
          The scope of the ISMS comprises the LoyalTfacts&reg; services including their development, operations and
          infrastructure deployed at Google Cloud Platform as well as their associated security, privacy, and compliance and inclusion
          of the requirements, control set and implementation guidance of ISO 27001, ISO 27017 and ISO 27018 per the Statement of Applicability.
          The Statement of Applicability is version 3. Loyal Solutions’ offices are in Copenhagen, Denmark (HQ) and Johannesburg, South Africa.
          Additionally, Loyal Solutions operates from teleworking locations.
        </p>
      </article>

      <article>
        <h4>AICPA SOC2 Certified</h4>
        <p>
          LoyalTfacts&reg; and Loyal Solutions are AICPA SOC2 certified. 
          SOC2 is a specific audit framework developed by the American Institute of Certified Public Accountants (AICPA) under their 
          Service Organization Control (SOC) reporting suite. SOC 2 is designed for organizations that provide technology, cloud computing, 
          and similar services to assess and ensure that they manage and protect customer data effectively.
        </p>
      </article>

      <article>
        <h4>GDPR and “store on soil” compliant</h4>

        <p>
          Being based in Denmark we are “GDPR native” and used to operating with some of the strictest data protection 
          regulations in the World - GDPR. For our non-EU and global clients, we are also compliant with local “store on soil” data laws.
          LoyalTfacts&reg; is by design able to store data at multiple global locations for the same program assuring 
          compliance for regional and global programs. Our data protection officer per GDPR is Tor Valstrøm, CIPM,CIPP/E,CISSP
        </p>
      </article>

      <article>
        <h4>PSD2 licensed</h4>

        <p>
          Processing financial data is especially sensitive. Loyal Solutions is approved under EUs PSD2 directive for Open Banking. 
          We are under supervision of the Danish Financial Authority (Finanstilsynet) and registered with an AISP license (FT ID# 45507). 
          This license allows us to connect to any bank and issuer within the EU in order to further enhance your loyalty program.
        </p>
      </article>

      <article class="last-item">
        <h4>Protecting client assets</h4>

        <p>
          Ensuring the integrity and security of our client’s assets is of the utmost importance to us. 
          We therefore continuously monitor and scan for any potential threats using the leading PCI Approved 
          Scanning Vendor, Qualys above and beyond the requirement in PCI and ISO.
        </p>
      </article>

      <div class="compliance-logos">
        <div class="logo-wrapper">
          <img src="@/assets/images/compliance/pci-dss-level-1-service-provider-certification.png" alt="PCI dss level 1 service provider certfications" class="logo">
          <img src="@/assets/images/compliance/ISO_27001_Certified_by_NIXU.png" alt="Certified by Nixu" class="logo">
          <img src="@/assets/images/compliance/21972-312_SOC_NonCPA.png" alt="Certified by Nixu" class="logo soc-logo">
          <img src="@/assets/images/compliance/eu-gdpr-compliant.png" alt="Eu gdpr compliant" class="logo">
          <img src="@/assets/images/compliance/finastilsynet.png" alt="Finanstilsynet" class="logo">
        </div>
      </div>
    </section>

  </app-view-template-secondary>
</template>

<script>
  import AppViewTemplateSecondary from '@/components/layout/templates/view/AppViewTemplateSecondary';
  import AppContentTitle from '@/components/ui/titles/AppContentTitle';

  export default {
      name: 'Compliance',

      components: {
        AppViewTemplateSecondary, AppContentTitle,
      },

      data: function() {
        return {
          brands: {
            title: '',
            items: [
              {
                label: 'Security is at the heart of everything we do.',
              },
            ],
          },
        }
      },
  }
</script>

<style lang="scss">
  .app-view-default-template-compliance {
    min-height: calc(100vh - 100px);

    @media (min-width: $lgBreakpoint) {
      .banners {
        background-image: url("../assets/images/compliance/compliance.jpg");
      }
    }

    section {
      width: 100%;
      margin-bottom: 0;

      article {
        width: 100%;
        margin-bottom: 30px;
      }
    }

    .compliance-logos {
      display: flex;
      justify-content: center;
      align-items: center;

      .logo-wrapper {
        max-width: 286px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 40px;

        .logo {
          &.soc-logo {
            width: 96px;
            height: 96px;
          }
        }

        @media (min-width: $mdBreakpoint) {
          width: 100%;
          max-width: $appWidth;
          justify-content: space-between;
        }

      }
    }
  }
</style>
